import { type Result } from '@carvana/merch-result';
import { axios, httpWithAuth } from '~/clients';
import { getGetRecentSearches } from '~/constants/endpoints';
import type { RecentSearch } from '~/contracts/home';

type RecentSearchesRequest = {
  browserCookieId: string;
  correlationId: string;
  count: number;
  zip5: string;
};

type RecentSearchesResponse = Result<{
  correlationId: string;
  recentSearches: RecentSearch[];
}>;

export default async function fetchRecentSearches(
  { browserCookieId, correlationId, count, zip5 }: RecentSearchesRequest,
  isLoggedIn: boolean,
  controller: AbortController
): Promise<RecentSearchesResponse> {
  const client = isLoggedIn ? httpWithAuth : axios;
  const path = getGetRecentSearches({ currentPageUrl: window.location.href });
  const query = new URLSearchParams({
    browserCookieId: browserCookieId,
    count: String(count),
    zip5
  });

  const { data } = await client.get<RecentSearchesResponse>(
    `${path}?${query.toString()}`,
    {
      headers: {
        'x-client-id': 'e902dfb1-f373-450d-8cca-9db2e12bfce5',
        'x-correlation-id': correlationId
      },
      signal: controller.signal
    }
  );

  return data;
}
